





































import VueOptions from '@utils/VueOptions'
import RecommendToCampaignsTrigger from './RecommendToCampaignsTrigger.coffee'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LoadingIndicator from '@/components/LoadingIndicator'
import CampaignSelector from '@ui/Campaign/CampaignSelector'

settings =
  name: 'RecommendToCampaignsTriggerModal'

  resources:
    campaigns:
      resourceName: 'campaign'
      slug: 'events/:eventId/campaigns/recommendations'
      params:
        match_target_only: ':matchTargetOnly'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LoadingIndicator, CampaignSelector }
    mixins: [RecommendToCampaignsTrigger.trigger()]

    data: ->
      matchTargetOnly: true

    computed:
      isLoading: -> !@campaigns || @requestIsPending
      eventId: -> @event.id
      modalConfig: -> @modal.config || {}
      event: -> @modalConfig.event || {}
      selectedKeys: -> @modal.data.campaign_ids || []
      actionsForCampaignSelector: ->
        {
          select: @selectCampaign,
          unselect: @unselectCampaign,
          selectAll: @selectAllCampaigns,
          unselectAll: @unselectAllCampaigns,
        }

    methods:
      modalData: -> { campaign_ids: [] }

      selectCampaign: (campaign) ->
        @modal.data.campaign_ids.push campaign.id
      unselectCampaign: (campaign) ->
        @modal.data.campaign_ids = @modal.data.campaign_ids.filter((id) -> campaign.key isnt id)
      selectAllCampaigns: (campaigns) ->
        @modal.data.campaign_ids = campaigns.map((campaign) -> campaign.key)
      unselectAllCampaigns: ->
        @modal.data.campaign_ids = []

    watch:
      matchTargetOnly: ->
        @clearDataForResourceKey('campaigns')
        @fetch('campaigns')

      'modal.show': (newValue, oldValue) ->
        isClosing = !newValue and oldValue
        if isClosing
          @matchTargetOnly = true
          @clearDataForResourceKey('campaigns')

export default VueOptions.vue settings
